import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Heading } from "@chakra-ui/react";
var PageHeading = function(_param) /*#__PURE__*/ {
    var children = _param.children, headingProps = _object_without_properties(_param, [
        "children"
    ]);
    return _jsx(Heading, _object_spread_props(_object_spread({
        as: "h1",
        size: "lg",
        textAlign: "center",
        mt: 2,
        mb: [
            6,
            null,
            7
        ]
    }, headingProps), {
        children: children
    }));
};
export default PageHeading;
